// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Bind = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Bind.purs");
var Control_Monad_ST_Internal = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/st/v5.0.1/src/Control/Monad/ST/Internal.purs");
var Control_Monad_Writer = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer.purs");
var Data_Argonaut_Core = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/argonaut-core/v6.0.0/src/Data/Argonaut/Core.purs");
var Data_Bifunctor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/bifunctors/v5.0.0/src/Data/Bifunctor.purs");
var Data_Codec = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec/v4.0.1/src/Data/Codec.purs");
var Data_Codec_Argonaut = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec-argonaut/v8.0.0/src/Data/Codec/Argonaut.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Foreign_Object = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object.purs");
var Foreign_Object_ST = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object/ST.purs");
var taggedSum = function (name) {
    return function (printTag) {
        return function (parseTag) {
            return function (f) {
                return function (g) {
                    var encodeCase = function (v) {
                        var $5 = g(v);
                        return Control_Monad_Writer.writer(Data_Tuple.Tuple.create(v)(Data_Codec.encode(Data_Codec_Argonaut.jobject)(Foreign_Object.runST(function __do() {
                            var obj = Foreign_Object_ST["new"]();
                            Foreign_Object_ST.poke("tag")(Data_Codec.encode(Data_Codec_Argonaut.string)(printTag($5.value0)))(obj)();
                            return Data_Maybe.maybe(Control_Applicative.pure(Control_Monad_ST_Internal.applicativeST)(obj))(function (v1) {
                                return Foreign_Object_ST.poke("value")(v1)(obj);
                            })($5.value1)();
                        }))));
                    };
                    var decodeCase = function (j) {
                        return Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Codec_Argonaut.Named.create(name))(Control_Bind.bind(Data_Either.bindEither)(Data_Codec.decode(Data_Codec_Argonaut.jobject)(j))(function (obj) {
                            return Control_Bind.bind(Data_Either.bindEither)(Data_Codec.decode(Data_Codec_Argonaut.prop("tag")(Data_Codec_Argonaut.string))(obj))(function (tag) {
                                var v = parseTag(tag);
                                if (v instanceof Data_Maybe.Nothing) {
                                    return new Data_Either.Left(new Data_Codec_Argonaut.AtKey("tag", new Data_Codec_Argonaut.UnexpectedValue(Data_Argonaut_Core.fromString(tag))));
                                };
                                if (v instanceof Data_Maybe.Just) {
                                    var v1 = f(v.value0);
                                    if (v1 instanceof Data_Either.Left) {
                                        return Control_Applicative.pure(Data_Either.applicativeEither)(v1.value0);
                                    };
                                    if (v1 instanceof Data_Either.Right) {
                                        return Control_Bind.bind(Data_Either.bindEither)(Data_Codec.decode(Data_Codec_Argonaut.prop("value")(Data_Codec_Argonaut.json))(obj))(function (value) {
                                            return Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Codec_Argonaut.AtKey.create("value"))(v1.value0(value));
                                        });
                                    };
                                    throw new Error("Failed pattern match at Data.Codec.Argonaut.Sum (line 68, column 9 - line 72, column 49): " + [ v1.constructor.name ]);
                                };
                                throw new Error("Failed pattern match at Data.Codec.Argonaut.Sum (line 65, column 5 - line 72, column 49): " + [ v.constructor.name ]);
                            });
                        }));
                    };
                    return new Data_Codec.GCodec(decodeCase, encodeCase);
                };
            };
        };
    };
};
var enumSum = function (printTag) {
    return function (parseTag) {
        var enc = function (a) {
            return Control_Monad_Writer.writer(new Data_Tuple.Tuple(a, Data_Codec.encode(Data_Codec_Argonaut.string)(printTag(a))));
        };
        var dec = function (j) {
            return Control_Bind.bind(Data_Either.bindEither)(Data_Codec.decode(Data_Codec_Argonaut.string)(j))(function (value) {
                var v = parseTag(value);
                if (v instanceof Data_Maybe.Just) {
                    return new Data_Either.Right(v.value0);
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return new Data_Either.Left(new Data_Codec_Argonaut.UnexpectedValue(j));
                };
                throw new Error("Failed pattern match at Data.Codec.Argonaut.Sum (line 33, column 5 - line 35, column 41): " + [ v.constructor.name ]);
            });
        };
        return new Data_Codec.GCodec(dec, enc);
    };
};
module.exports = {
    enumSum: enumSum,
    taggedSum: taggedSum
};

